import * as React from 'react';

import { IfacilityContact, Itile } from '../../models';
import ReactTable, { Column, FinalState, RowInfo } from 'react-table';
import {
    deleteFacilityFromContact,
    updateSelectedContact
} from '../../actions/manageFacilityActions';

import { ContactActionButton } from './ContactActionButton';
import { TFunction } from 'i18next';
import { TableUtil } from '../common/TableUtil';
import { constants } from '../../constants/constants';
import moment from 'moment';

interface Iprops {
    t: TFunction;
    tableData: Array<IfacilityContact>;
    loading: boolean;
    currentTile: Itile;
    facilityID: string;
    selectedContactID: string;
    colorButton: string;
    deleteFacilityFromContact: typeof deleteFacilityFromContact;
    updateSelectedContact: typeof updateSelectedContact;
    addContactLead?: (contact: IfacilityContact) => void;
    onEditContact?: (contact: IfacilityContact) => void;
    onPreviewContact?: (contact: IfacilityContact) => void;
    readOnly?: boolean;
}
interface Istate {
    selectedRow: any;
    columns: Array<{}>;
}
interface RowInfoEdited extends RowInfo {
    original: IfacilityContact;
}

export class AddContactsTable extends React.PureComponent<Iprops, Istate> {
    static defaultProps = {
        currentTile: constants.getTileByURL(window.location.pathname),
        tableData: []
    };
    constructor(props: Iprops) {
        super(props);
        this.state = {
            selectedRow: {},
            columns: this.columns()
        };
    }
    componentDidUpdate(prevProps: Iprops) {
        if (
            this.props.selectedContactID !== prevProps.selectedContactID &&
            this.props.selectedContactID.length === 0
        ) {
            this.setState({ selectedRow: {} });
        }
    }

    handleSelectContactEdit = (rowInfo: RowInfoEdited) => {
        this.setState({
            selectedRow: rowInfo.index
        });
        this.props.updateSelectedContact(rowInfo.original);
        if (this.props.onEditContact) {
            this.props.onEditContact(rowInfo.original);
        }
    };

    handleSelectContactPreview = (rowInfo: RowInfoEdited) => {
        if (!this.props.onPreviewContact) {
            return;
        }
        this.setState({
            selectedRow: rowInfo.index
        });
        this.props.onPreviewContact(rowInfo.original);
    };

    columns = () => {
        const columns: Column[] = [
            {
                Header: 'First',
                accessor: 'firstName',
                width: 85
            },
            {
                Header: 'Last',
                accessor: 'lastName',
                width: 85
            },
            {
                Header: 'SRC',
                accessor: 'source',
                width: 42,
                Cell: row =>
                    row.value === 0 ? 'MMG' : row.value === 1 ? 'SAP' : ''
            },
            {
                Header: 'facilityContactForm.lastUsedJob',
                accessor: 'lastSignedJobNumber',
                width: 92
            },
            {
                Header: 'facilityContactForm.lastSignedDate',
                accessor: 'lastSignedDate',
                width: 78,
                Cell: row =>
                    row.value
                        ? moment(row.value).format(
                              constants.momentDisplayFormat
                          )
                        : ''
            }
        ];
        if (!this.props.readOnly) {
            columns.push({
                Header: '',
                id: 'actions',
                width: 36,
                style: { overflow: 'visible' },
                Cell: row => {
                    return (
                        <ContactActionButton
                            t={this.props.t}
                            rowInfo={row}
                            colorButton={this.props.colorButton}
                            facilityID={this.props.facilityID}
                            deleteFacilityFromContact={
                                this.props.deleteFacilityFromContact
                            }
                            handleSelectContactEdit={
                                this.handleSelectContactEdit
                            }
                            addContactLead={this.props.addContactLead}
                        />
                    );
                }
            });
        }
        return TableUtil.translateHeaders(columns, this.props.t);
    };
    /*
     * (reusable)
     * Handle user clicking on a product row
     * set the selected product to state and open the modal
     */
    getTrProps = (state: FinalState, rowInfo: RowInfoEdited | undefined) => {
        if (rowInfo) {
            return {
                onClick: () => this.handleSelectContactPreview(rowInfo),
                style: {
                    cursor: this.props.onPreviewContact ? 'pointer' : '',
                    background:
                        rowInfo.index === this.state.selectedRow
                            ? constants.colors[
                                  `${this.props.currentTile.color}Tr` as keyof typeof constants.colors
                              ]
                            : ''
                }
            };
        } else {
            return {};
        }
    };

    render() {
        const { tableData, t } = this.props;

        const tableClassName = `beacon-table contacts -highlight ${this.props.currentTile.color}`;
        return (
            <div style={{ marginTop: '20px' }}>
                <ReactTable
                    data={tableData}
                    columns={this.state.columns}
                    getTrProps={this.getTrProps}
                    pageSize={tableData.length || 1}
                    minRows={0}
                    // getTdProps={this.getTdProps}
                    showPageSizeOptions={false}
                    showPagination={false}
                    className={tableClassName}
                    sortable={false}
                    multiSort={false}
                    noDataText={t('facilityContactForm.noContacts')}
                    resizable={false}
                    style={{ height: '100%' }}
                    // loading={loading}
                />
            </div>
        );
    }
}
